import React, { useState, Fragment, useEffect, useLayoutEffect } from 'react';
import styles from './SchConChanges.module.css';
import { Card, Col, Input, Row, Select, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData, useConAppQry } from '../../../../api';
import { crawl } from '../../../../api/util';
import { conApps, trafficApps, cardCss, tabPageCss } from './columns';
const { Option } = Select;
const { Text } = Typography;

const SchConChanges = (props) => {
    const [renderer, updateRender] = useState('tab1');
    const key = props.usrSch == 'Scheduled' ? 1 : props.usrSch == 'Deployed' ? 0 : 2;
    const inp1 = {
        type: 'fetch',
        qry: 'fetConSchApps',
    };
    const inp2 = {
        type: 'fetch',
        qry: 'fetConTrafSchApps',
    };
    const { data, isLoading, isError } = useConAppQry(renderer === 'tab1' ? inp1 : inp2, renderer);

    const onTabChng = (key) => {
        updateRender(key);
        props.setSubmit(!props.submit);
    };

    const contentList = {
        tab1: (
            <FetchTabSearch
                submit={props.submit}
                col={conApps}
                data={data}
                usrSch={key}
                loading={isLoading}
                loader={props.loader}
                key={'1'}
            />
        ),
        tab2: (
            <FetchTabSearch
                submit={props.submit}
                col={trafficApps}
                data={data}
                usrSch={key}
                loading={isLoading}
                loader={props.loader}
                key={'2'}
            />
        ),
    };

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={23}>
                    <Card
                        style={{ width: '100%', minHeight: '80vh' }}
                        bodyStyle={cardCss}
                        tabList={tabList}
                        onTabChange={onTabChng}
                        loading={isLoading}
                    >
                        {!isLoading && !props.loader ? (
                            contentList[renderer]
                        ) : (
                            <div className={styles.spinner}>
                                <Spin size="small" />
                            </div>
                        )}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);

    const schData =
        props.usrSch === 1
            ? props.data.filter((item) => item.deployment_status === 1)
            : props.usrSch === 0
            ? props.data.filter((item) => item.deployment_status === 0)
            : props.data;

    const schColIndicator =
        props.usrSch === 1 ? 'Scheduled Date' : props.usrSch === 0 ? 'Deployed Date' : 'Scheduled / Deployed Date';

    useEffect(() => {
        setLoading(true);

        setOrigData(schData);
        setFilteredData(schData);
        const searchInd = schData.map((user) => {
            const allValues = crawl(user);
            return { allValues: allValues.toString() };
        });
        setSearchIndex(searchInd);

        setLoading(false);
    }, [props.usrSch]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.usrSch]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={6}>
                                            <Text>
                                                {props.usrSch === 1
                                                    ? 'Scheduled'
                                                    : props.usrSch === 0
                                                    ? 'Deployed'
                                                    : 'All'}
                                            </Text>
                                        </Col>
                                    </Row>
                                )
                            }
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey={(_, index) => index}
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props
                                        .col(filteredData.length, schColIndicator)
                                        .filter((col) => col.hidden !== false)}
                                    loading={false}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const tabList = [
    {
        key: 'tab1',
        tab: 'Modified Connectors',
    },
    {
        key: 'tab2',
        tab: 'Traffic Changes',
    },
];

export default SchConChanges;
